import React from 'react';

import classNames from 'classnames';

class CardHeader extends React.Component {
  render() {
    const { children } = this.props;
    return <div className={classNames('c-card__header')}>{children}</div>;
  }
}

export default CardHeader;
